export enum SearchResultType {
    NotVerifiedItem,
    ShortedItem,
    ChangedItem,
    VerifiedItem,
    LicensePlate,
    ReturnItem
}